import { ToastProps, ToastType, ToastWidget } from '@tableau/widgets';
import * as React from 'react';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';
import { IToast, ToasterService } from '../../../ts/services/ToasterService';
import { Toast } from './Toast';

const FIRST_TOAST_TOP_MARGIN = 15;
const OFFSET_BETWEEN_TOASTS = 45;
const LEGACY_TOAST_CONTAINER_STYLE = {top: '4px', className:'tb-toaster tb-enable-selection'};

export class Toaster extends React.Component<Toaster.Props, Toaster.State> {

  public static displayName = 'Toaster';

  state: Toaster.State = {toasts: []};

  public static element = React.createFactory(Toaster);
  private angularContext: AngularContext;

  private listenerId: number;

  private toasterService: ToasterService;

  private boundListenerFn: (t: IToast[]) => void = this.toastsUpdated.bind(this);

  constructor(props: Toaster.Props) {
    super(props, {});
    this.angularContext = this.props.angularContext;
    this.toasterService = this.angularContext.getService('ToasterService');
  }

  public componentDidMount() {
    this.listenerId = this.toasterService.addListener({toastsUpdated: this.boundListenerFn});
  }

  public componentWillUnmount() {
    this.toasterService.removeListener(this.listenerId);
  }

  private close(id: number) {
    this.toasterService.close(id);
  }

  public toastsUpdated(toastArray: IToast[]) {
    this.setState({toasts: toastArray});
  }

  public render() {
    //TODO: TFS:955286: Remove the div wrapper once we get rid of all deprecated uses of IToast.content
    return React.createElement('div', {style: LEGACY_TOAST_CONTAINER_STYLE},
      this.state.toasts.map(this.renderToastWidget));
  }

  private renderToastWidget = (toastInfo: IToast, index: number) => {
    if (toastInfo.lines || toastInfo.children) {
      return React.createElement(ToastWidget, {
        testId: toastInfo.testId,
        key: toastInfo.id,
        onCloseRequest: () => this.close(toastInfo.id),
        toastType: convertToastType(toastInfo.type),
        message: toastInfo.lines ? toastInfo.lines.join('\n') : '',
        children: toastInfo.children,
        autoDismiss: true,
        topLeftYPx: FIRST_TOAST_TOP_MARGIN + index * OFFSET_BETWEEN_TOASTS,
        onAction: toastInfo.action,
        actionMessage: toastInfo.actionMessage,
        actionHref: 'javascript:void(0)'
      });
    } else { //TODO: TFS:955286: Remove this branch once we remove all deprecated uses of IToast.content
      return Toast.element({
        key: toastInfo.id,
        close: () => this.close(toastInfo.id),
        toastType: toastInfo.type,
        timeoutDelay: toastInfo.timeoutDelay,
        toastContent: toastInfo.content,
        lines: toastInfo.lines,
        testId: toastInfo.testId,
      });
    }
  }
}

function convertToastType(type: string) {
  switch (type) {
    case 'info':
      return ToastType.Info;
    case 'error':
      return ToastType.Error;
    case 'warning':
      return ToastType.Warning;
    //this commented out types existed on the old toast, but dont exist on shared widgets.
    // case 'external':
    // case 'infonofadeout':
    default:
      return ToastType.Success;
  }
}

export module Toaster {

  export interface Props extends ReactDirectiveProps {
    angularContext: AngularContext;
  }

  export interface State {
    toasts?: IToast[];
  }

}
